import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { currentPrice, compareAtPrice } from "../store/product-store";
import { effect } from "@preact/signals-core";
import { formatToDollarCurrencyString } from "../utils/knocking";

@customElement("price-pp")
export class PricePP extends LitElement {
  @property({ type: String }) price: string | null = null;
  @property({ type: String }) compareAtPrice: string | null = null;

  constructor() {
    super();

    effect(() => {
      this.price = currentPrice.value;
      this.compareAtPrice = compareAtPrice.value;
    });
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  private _formatPrice(value: string | number | null | undefined): string {
    if (value == null || value === "") return "N/A";
    const cents = typeof value === "string" ? parseInt(value, 10) : value;
    if (Number.isNaN(cents)) return "N/A";
    return formatToDollarCurrencyString(cents);
  }

  private _toCents(value: string | number | null | undefined): number | null {
    if (value == null || value === "") return null;
    const cents = typeof value === "string" ? parseInt(value, 10) : value;
    if (Number.isNaN(cents)) return null;
    return cents;
  }

  render() {
    const priceFormatted = this._formatPrice(this.price);
    const compareCents = this._toCents(this.compareAtPrice);
    const compareFormatted =
      compareCents != null && compareCents > 0
        ? this._formatPrice(compareCents)
        : null;
    const isCompact = this.hasAttribute("compact");

    return html`
    <div class="flex items-center gap-3 md:gap-7.5">
      <span
        class="price-pp__current ${isCompact ? "text-lg md:text-3xl" : "text-3xl"} font-bold text-[var(--color-secondary-500)]"
      >${priceFormatted}</span>
        ${compareFormatted
          ? html`<span class="price-pp__compare text-sm line-through font-medium text-[var(--color-secondary-800)]">${compareFormatted}</span>`
          : ""}
      </div>
    `;
  }
}
